import BaseProxy from './base-proxy';

/**
 * Class ProductProxy
 */
class ProductProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api', parameters);
  }

  /**
   * @param {Object} params - { page, page_size, search }
   * @returns {Promise}
   */
  list(params = {}) {
    this.setParameters(params);
    return this.submit('get', `${this.endpoint}/products/`, null, { showResponseStatus: true });
  }

  /**
   * @param {number} id
   * @returns {Promise}
   */
  detail(id) {
    return this.submit('get', `${this.endpoint}/products/${id}/`);
  }

  /**
   * @param {Object} data - { name, price, unit, rate, category, ... }
   * @returns {Promise}
   */
  create(data) {
    return this.submit('post', `${this.endpoint}/products/`, data);
  }

  /**
   * @param {number} id
   * @param {Object} data - { name, unit, price, ... }
   * @returns {Promise}
   */
  update(id, data) {
    return this.submit('put', `${this.endpoint}/products/${id}/`, data);
  }

  /**
   * @param {number} id
   * @param {Object} data
   * @returns {Promise}
   */
  patch(id, data) {
    return this.submit('patch', `${this.endpoint}/products/${id}/`, data);
  }

  /**
   * @param {number} id
   * @returns {Promise}
   */
  delete(id) {
    return this.submit('delete', `${this.endpoint}/products/${id}/`);
  }
}

export default ProductProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/product-proxy.js